export const REGISTERED_VOLUNTEERS = 680000
export const REGISTERED_ORGANIZATIONS = 17000
export const AVAILABLE_MISSIONS = 20000
export const VOLUNTEERS_NEEDED = 140000
